function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophoneEmpty = function SvgMicrophoneEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.319 5.778c0-2.926-2.362-5.297-5.275-5.297-2.913 0-5.274 2.371-5.274 5.297v7.945a5.295 5.295 0 0 0 3.966 5.132c-.007.054-.01.109-.01.164v2.539c-3.742-.63-6.593-3.899-6.593-7.835 0-.732-.59-1.324-1.32-1.324-.727 0-1.318.592-1.318 1.324 0 5.402 4.027 9.86 9.23 10.511v1.406c0 .732.591 1.324 1.32 1.324.728 0 1.318-.592 1.318-1.324v-1.406c5.204-.652 9.23-5.11 9.23-10.511 0-.732-.59-1.324-1.318-1.324-.728 0-1.319.592-1.319 1.324 0 3.936-2.851 7.204-6.593 7.835v-2.539c0-.055-.003-.11-.01-.164a5.295 5.295 0 0 0 3.966-5.132zm-5.275-2.649a2.643 2.643 0 0 0-2.637 2.649v7.945a2.643 2.643 0 0 0 2.637 2.648 2.643 2.643 0 0 0 2.638-2.648V5.778a2.643 2.643 0 0 0-2.638-2.649z",
    style: {
      strokeWidth: 1.3214
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 7.917,
    y: 39.605
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.917,
    y: 39.605,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "10.6667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "MIC")));
};
export default SvgMicrophoneEmpty;